import React from 'react';
import {BASE_PATH_PORTAL} from 'constants/general';

export function HeaderTiendasMenu() {

    return(
        <nav className="menuTiendas">
            <ul>
                <li>
                    <a href={`${BASE_PATH_PORTAL}/tiendas`}>Tiendas Oficiales</a>
                </li>
                <li>
                    <a href={`${BASE_PATH_PORTAL}/l/faqs/`}>¿Necesitas ayuda?</a>
                </li>
            </ul>
        </nav>
    )
}